import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useRef } from "react";
var handleSkipToMain = function (e) {
    var _a;
    e.preventDefault();
    (_a = wmrk === null || wmrk === void 0 ? void 0 : wmrk.gotoMain) === null || _a === void 0 ? void 0 : _a.call(wmrk);
};
var handleSkipToNav = function (e) {
    var _a;
    e.preventDefault();
    (_a = wmrk === null || wmrk === void 0 ? void 0 : wmrk.gotoNav) === null || _a === void 0 ? void 0 : _a.call(wmrk);
};
export default function SkipMenu(_a) {
    var _b = _a.showNavigation, showNavigation = _b === void 0 ? true : _b;
    if (!showNavigation) {
        return (_jsx("section", { id: "skip-to-menu", "aria-label": "Skip to main content", children: _jsx("a", { className: "skip-to", href: "#maincontent", accessKey: "0", onClick: handleSkipToMain, children: "Skip to Main Content" }) }));
    }
    return _jsx(SkipMenuWithDropdown, {});
}
function SkipMenuWithDropdown() {
    var initializedRef = useRef(false);
    var initializeMenu = useCallback(function (event) {
        var _a, _b;
        if (initializedRef.current) {
            return;
        }
        var addSkipMenu = (_b = (_a = window === null || window === void 0 ? void 0 : window.wmrk) === null || _a === void 0 ? void 0 : _a.Utils) === null || _b === void 0 ? void 0 : _b.addSkipMenu;
        if (addSkipMenu) {
            addSkipMenu(event.nativeEvent);
            initializedRef.current = true;
        }
    }, []);
    return (_jsxs("section", { id: "skip-to-menu", "aria-label": "Skip navigation shortcuts", children: [_jsx("a", { className: "skip-to", href: "#skip-menu-options", accessKey: "0", role: "button", "aria-expanded": "false", "aria-controls": "skip-menu-options", onFocus: initializeMenu, children: "Skip to ..." }), _jsxs("ul", { id: "skip-menu-options", "aria-label": "Skip navigation destinations", children: [_jsx("li", { children: _jsx("a", { className: "skiplink", tabIndex: -1, href: "#maincontent", onClick: handleSkipToMain, id: "skip-1", children: "Main Content" }) }), _jsx("li", { children: _jsx("a", { className: "skiplink", tabIndex: -1, href: "#navmenu", onClick: handleSkipToNav, id: "skip-2", children: "Navigation" }) })] })] }));
}
